export const TIPO_DETALHE = {
  CAMPO: 1,
  TOTAL: 2,
  CAMPO_TOTAL: 3,
};
